import { Cell } from '@pelckmans/elementis/components/table';
import { getResultPercentages, getStatusForScorableItem } from '../../../../../../../../utils/results';
import useTableData from '../../../hooks/useTableData';

type ScorableItemResultCellProps = {
  materialId: string;
  memberId: string;
  type: 'assignment' | 'free-exercise';
  quantifiable: boolean;
  getResult: ReturnType<typeof useTableData>['getResultForScorableMaterial'];
};

export default function ScorableItemResultCell({
  materialId,
  memberId,
  type,
  quantifiable,
  getResult,
}: ScorableItemResultCellProps) {
  const result = getResult(memberId, materialId, type);
  if (!result) return <Cell />;

  const status = getStatusForScorableItem(result);

  if (!quantifiable) {
    return (
      <Cell>
        <Cell.Results quantifiable={false} status={status} showTooltip variant="full" />
      </Cell>
    );
  }

  return (
    <Cell>
      <Cell.Results
        quantifiable
        status={status}
        showTooltip
        variant="full"
        {...getResultPercentages(result.score, result.needsGrading)}
      />
    </Cell>
  );
}
